import { createAdminApi } from './admin.js';
import type { AdminApi } from './admin.js';
import { createAuthApi } from './auth.js';
import type { AuthApi } from './auth.js';
import { createBlocksApi } from './blocks.js';
import type { BlocksApi } from './blocks.js';
import { createFriendsApi } from './friends.js';
import type { FriendsApi } from './friends.js';
import { createGamesApi } from './games.js';
import type { GamesApi } from './games.js';
import { createGameSessionsApi } from './game-sessions.js';
import type { GameSessionsApi } from './game-sessions.js';
import { HttpClient } from './http-client.js';
import type { ApiClientOptions } from './http-client.js';
import { createInvitationsApi } from './invitations.js';
import type { InvitationsApi } from './invitations.js';
import { createNotificationsApi } from './notifications.js';
import type { NotificationsApi } from './notifications.js';
import { createUsersApi } from './users.js';
import type { UsersApi } from './users.js';

export interface ApiClient {
  admin: AdminApi;
  auth: AuthApi;
  games: GamesApi;
  gameSessions: GameSessionsApi;
  users: UsersApi;
  friends: FriendsApi;
  blocks: BlocksApi;
  notifications: NotificationsApi;
  invitations: InvitationsApi;
}

/**
 * Builds the typed API client (docs/APP_PLAN.md §5.2, §12 M2b, M3, M4). One
 * `HttpClient` transport is shared by every domain, including admin, so cookie/CSRF handling and
 * error decoding live in exactly one place.
 */
export function createApiClient(options: ApiClientOptions = {}): ApiClient {
  const http = new HttpClient(options);
  return {
    admin: createAdminApi(http),
    auth: createAuthApi(http),
    games: createGamesApi(http),
    gameSessions: createGameSessionsApi(http),
    users: createUsersApi(http),
    friends: createFriendsApi(http),
    blocks: createBlocksApi(http),
    notifications: createNotificationsApi(http),
    invitations: createInvitationsApi(http),
  };
}
